export enum NoteErrorCode {
  CannotAssignAdminWithoutAccess = 'cannot_assign_admin_without_access',
}
